// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"0f7d2a18","326":"b1940699","384":"9ac30738","833":"77646d55","941":"791d0644"}[chunkId] + ".chunk.css";
};